import { AxiosHttpPost } from 'axios-http';
import { RMAMANUFATURA } from 'resources/links';

export function uploadRmaExcel(formFile: File, ssoId: string) {
  const formData = new FormData();
  formData.append("file", formFile); 
  formData.append("ssoId", ssoId);

  return AxiosHttpPost({
    url: RMAMANUFATURA.uploadExcelManufacturing, 
    data: formData,
    headers: { Accept: "*/*" } 
  });
}
